import {DirectusTranslation} from './translation';

export enum FulfillmentType {
  TERNARY = 'ternary',
  BOOLEAN = 'boolean',
  NUMERIC = 'numeric',
  PERCENTAGE = 'percentage',
}

export interface AttributeFulfillmentTypeDirectus {
  id: number;
  type: FulfillmentType;
  translations?: DirectusTranslation[];
}
